import React from 'react';

export const SocialLinkIcon = ({ link }: { link: string }) => {
    return <a href={link}>Icon</a>;
};

export default SocialLinkIcon;
